import React from 'react'
import * as Displays from 'support/displays'
import { WhenModelValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'

export default function OpenShift ({ mode = 'view' }) {

  return (
    <>
      <WhenModelValue name={'user_id'}>
        <Displays.Text name="user.name"/>
      </WhenModelValue>

      <WhenModelValue name={'user_id'} negate>
        <Translation name="shiftexchange.status.open_shift"/>
      </WhenModelValue>
    </>
  )
}
